function applyShadow(shadowType){

document
.querySelectorAll(".curve-letter")
.forEach(letter=>{

letter.classList.remove(
"soft-shadow",
"drop-shadow",
"offset-shadow"
);

if(
shadowType === "none" ||
!shadowType
) return;

letter.classList.add(
shadowType + "-shadow"
);

});

}
document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#shadow-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "shadowEmbroidery"
      );

    if (!cards.length || !hidden)
      return;

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
card.dataset.shadow;

applyShadow(
card.dataset.shadow
);

const activeLayer =
document.querySelector(
".embroidery-text-layer.active-layer"
);

if(activeLayer){

activeLayer.dataset.shadow =
card.dataset.shadow;

}

          console.log(
            "SHADOW:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);